<div class="ion-header ion-hide-lg-up h">
  <header-main></header-main>
  <div class="ion-fab">
    <div class="ion-fab-button close button-tertiary button-round">
      <a href="/how-it-works">
        <img class="ion-icon" src="assets/icons/close.svg">
      </a>
    </div>
  </div>
</div>

<main class="ion-content" fullscreen>
  <header class="ion-hide-lg-down g">
    <header-desktop></header-desktop>
    <h1>
      <svg class="ion-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.4 30.16"><defs><style>.gigs{stroke:none;}</style></defs><title>gigs</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="gigs" d="M13.44,30.16h-.12A15.18,15.18,0,0,1,13.32,0a1,1,0,0,1,1.12.87A1,1,0,0,1,13.57,2a13.19,13.19,0,0,0-1.13,26V16.74H7.22a1,1,0,0,1,0-2h6.22a1,1,0,0,1,1,1V29.16a1,1,0,0,1-.33.75A1,1,0,0,1,13.44,30.16Zm4.64,0A15.18,15.18,0,0,0,18.08,0,1,1,0,0,0,17,.88,1,1,0,0,0,17.83,2,13.19,13.19,0,0,1,19,28V16.74h5.22a1,1,0,0,0,0-2H18a1,1,0,0,0-1,1V29.16a1,1,0,0,0,.33.75,1,1,0,0,0,.67.25ZM18.9,10a3.2,3.2,0,1,0-3.2,3.2A3.21,3.21,0,0,0,18.9,10Zm-2,0a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,16.9,10Z"/></g></g></svg>
      How it works: Gigs
    </h1>
  </header>

  <div class="container-fluid details-wrapper">
    <div class="row">
      <div class="col col-xs-12 col-md-10 col-lg-8 col-xl-6 col-md-offset-1 col-lg-offset-2 col-xl-offset-3">
        <div class="details-content">
          <img class="ion-margin-bottom" src="assets/images/how-it-works/gigs.jpg" alt="Gigs">
          <div>
            <div class="description">
              <h1><strong>What is a gig and how does it work?</strong></h1>

              <p>A gig is a detailed task, or set of assignments, with a specific pre-defined outcome.</p>

              <p>As a gig lister you post a listing under the category that best aligns with your needs. These categories span the whole economy, ranging from consumer home &amp; garden, to corporate business, hospitality or rural farming.</p>
              
              <h2><span>What is the process?</span></h2>
              
              <h3>1. Outline your requirements &amp; expectations</h3>
              
              <p>List your negotiable or fixed price gig with us by detailing your scope of works, price &amp; expected outcome.</p>
              
              <h3>2. Selecting your worker</h3>

              <p>We will present 5 suitable gig workers who have applied for your gig. You may reject unsuitable workers, we will keep presenting new workers (5 maximum) until you find your perfect match.</p>
              
              <p>Chat privately with each gig worker to determine their skills and suitability.</p>

              <p>If the gig is fixed price, the gig worker applies accepting the scope of work and price at the initial application stage.</p>

              <p>If the gig is negotiable, the gig lister and gig worker may privately chat to determine the full scope of works and associated pricing. Additional scope and price changes can occur after the gig is inflight too, as we all know things can unexpectedly change.</p>
              
              <p>Accept the gig worker most suited, this will automatically inform all other gig workers they have missed out on the gig this time.</p>
              
              <h3>3. Agreeing to terms</h3>
              
              <p>The terms and pricing are then agreed by both parties and the gig is locked.</p>
              
              <p>These conversations take place in a fully audited, secure, private real-time chat portal. It’s important to keep discussions with gig workers in this chat portal, for peace of mind should any disputes arise. The real-time chat portal will also be used to manage and monitor the gig, end to end.</p>
              
              <p>Work can then begin on the gig. Keep in touch via the chat portal.</p>
              
              <h3>4. The gig fee</h3>
              
              <p>Payment is released after agreement and it is then held in a secure third party Stripe escrow account until work is completed. It is only released upon satisfaction by the gig lister.</p>
              
              <p>Using a third party account, of a global leading payment provider, offers peace of mind for both parties. However it’s important to note that Stripe enforce a 90-day limit per gig, after which the payment will be automatically released. If you’re in doubt about whether your gig may come under the 90-day limit, we recommend shortening the gig into smaller stages. </p>
              
              <h3>5. Completing the gig &amp; leaving feedback</h3>
              
              <p>When the gig’s complete, the gig worker notifies the gig lister of completion who can then release the funds to the gig worker. Happy with how it went? Both parties can leave feedback on their experience working with each other. Each party can respond to a review. Gig done!</p>
              
              <h4>Find out <a routerLink="/support/gig-lister/difference-between-gig-job">here</a> whats the difference between a gig and a job?</h4>
              
              <h4>Find out <a routerLink="/support/gig-lister/difference-between-gig-contract">here</a> whats the difference between a gig and a contract?</h4>
               
              <h2><u><strong>How it works for the gig lister</strong></u></h2>
              
              <p>The gig lister can be a consumer, freelancer, contractor or a business who needs help with completing any type of specific task, with an expected outcome.</p>
              
              <p>What can you expect as a gig lister? gigexchange has been designed to offer you:</p>
              
              <ul>
                <li><strong>Simplicity</strong><br>
                This is a safe and secure marketplace where you can easily access leading service providers, who you otherwise may not have found, in one easy to use platform</li>
                <li><strong>Confidence</strong><br>
                Confidently choose a provider by viewing feedback provided by other gig listers on previous projects</li>
                <li><strong>Trust</strong><br>
                Pay online with confidence thanks to our safe and secure payments system that is designed to protect both gig listers, and gig workers, from getting caught out</li>
                <li><strong>Relationships</strong><br>
                Feedback goes two ways, meaning you can use the platform to grow your own brand and relationships with providers, making it easier to find great gig workers</li>
                <li><strong>Quality</strong><br>
                Our feedback system helps ensure we keep the marketplace full of those who offer a high standard of honest work. It’s a respectful working environment - no exploiters welcome.</li>
                <li><strong>Promotion</strong><br>
                Brands with a strong positive reputation will be promoted, attracting top quality talent for all ways of working</li>
                <li><strong>Peace of mind</strong><br>
                We offer a comprehensive and fair disputes policy in conjunction with our leading payment provider to ensure a satisfactory outcome for all parties.</li>
                <li><strong>Fairness</strong><br>
                gigexchange is a win-win platform for both buyers and sellers of work, with fair pricing, quality projects and fair working relationships.</li>
                <li><strong>Convenience</strong><br>
                as a unique marketplace offering all ways of working &amp; advertising we have an active and dynamic customer base of the very best (and validated) buyers and sellers of all things work</li>
              </ul>

              <p>Together, we can create an ecosystem of great work, trust, respect and integrity - for the benefit of both buyers and sellers of work.</p>
                            
              <h2><u><strong>How it works for the gig worker</strong></u></h2>
              
              <p>The gig worker is an individual  (side hustler/freelancer/contractor) or business who is available to complete tasks in exchange for an agreed fee.</p>

              <p>What can you expect as a gig worker? gigexchange has been designed to help you:</p>

              <ul>
                <li><strong>Showcase your services</strong><br>
                You can use our promote section to advertise your services (for a small fee), but backed by our reputation to validate your brand.</li>
                <li><strong>Build your reputation</strong><br>
                We provide a reputation system for both gig listers and gig workers, to help grow your brand through hard work, trust, respect &amp; integrity</li>
                <li><strong>Become a trusted supplier</strong><br>
                Our reputation system will ensure the marketplace is predominantly occupied by those that offer honest, hard work. As well as a safe, secure and respectful working environment. No exploiters welcome</li>
                <li><strong>Earn what you’re worth</strong><br>
                Earn fair and reasonable rates from gig listers who recognise the value in what you’ve got to offer. No undercutting local market rates here</li>
                <li><strong>Get paid securely</strong><br>
                We partner with a leading global gateway provider, who immediately place the money in an independent escrow account, while you complete the work, offering peace of mind that you will get paid for the work you have agreed to and completed</li>
                <li><strong>Settle disputes fairly</strong><br>
                We offer a comprehensive and fair disputes policy in conjunction with our leading payment provider to ensure a satisfactory outcome for all parties.</li>
                <li><strong>Fair fees</strong><br>
                As work engagements become smaller and more irregular, we believe the worker (ie the 'doer') deserves to pay the lowest fees possible.</li>
              </ul>

              <p>Together, we can create an ecosystem of hard work, trust, respect and integrity - for the benefit of both gig listers, and gig workers.</p>
              
              <p>For more information see our <a routerLink="/support">Help Centre</a> &amp; <a href="/faqs">FAQs</a>.</p>

              <h5>gigexchange, the fastest growing gig economy platform. Empowering the gig economy win</h5>
            </div>
          </div>
          <div class="details-author">
            <p>Posted by: gigexchange</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="ion-hide-lg-down">
    <footer-desktop></footer-desktop>
  </footer>
</main>

<footer class="ion-hide-lg-up">
  <footer-main></footer-main>
</footer>
